// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"11214106","455":"78f93361"}[chunkId] + ".chunk.js";
};